/* eslint-disable */
import React from 'react';

const ProgramLogo = ({ fill, className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} style={{ width: 24, height: 24, marginLeft: -3, }} viewBox="0 -960 960 960" width="24px"
       fill={fill || '#FFFFFF'}>
    <path
      d="M184.62-200q-27.62 0-46.12-18.5Q120-237 120-264.62v-430.76q0-27.62 18.5-46.12Q157-760 184.62-760h590.76q27.62 0 46.12 18.5Q840-723 840-695.38v200h-40V-640H160v375.38q0 9.24 7.69 16.93 7.69 7.69 16.93 7.69h261.53v40H184.62ZM729.23-64.61q-63.77 0-113.27-38.58-49.5-38.58-66.58-96.81h37.39q16.08 44.77 54.11 72.38Q678.92-100 729.23-100q63.39 0 107.85-44.46 44.46-44.46 44.46-107.85 0-63.38-44.46-107.84t-107.85-44.46q-36.69 0-70.15 17.8Q625.62-369 601.23-340h75.69v35.39H541.54V-440h35.38v73.92q28.54-32.92 68.39-53.42 39.84-20.5 83.92-20.5 77.62 0 132.65 55.04 55.04 55.04 55.04 132.65 0 77.62-55.04 132.66-55.03 55.04-132.65 55.04Z" />
  </svg>
);

export default ProgramLogo;
